import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Home from './components/Home';  
import About from './components/About';  
import Contact from './components/Contact';  
import Services from './components/Services';  
import Footer from './components/Footer';
import Application from './components/Application';
import LicensePage from './components/LicensePage';

// Importez ici vos composants de politique de confidentialité
import PrivacyPolicyPage from './components/PrivacyPolicyPage';
import PrivacyPolicyPageAr from './components/PrivacyPolicyPageAr';
import PrivacyPolicyPageDe from './components/PrivacyPolicyPageDe';
import PrivacyPolicyPageEs from './components/PrivacyPolicyPageEs';
import PrivacyPolicyPageFr from './components/PrivacyPolicyPageFr';
import PrivacyPolicyPageHi from './components/PrivacyPolicyPageHi';
import PrivacyPolicyPageId from './components/PrivacyPolicyPageId';
import PrivacyPolicyPageIt from './components/PrivacyPolicyPageIt';
import PrivacyPolicyPageJa from './components/PrivacyPolicyPageJa';
import PrivacyPolicyPageRu from './components/PrivacyPolicyPageRu';
import PrivacyPolicyPageTr from './components/PrivacyPolicyPageTr';
import PrivacyPolicyPageZh from './components/PrivacyPolicyPageZh';

import PrivacyPolicyPageEnLite from './components/PrivacyPolicyPageEnLite';
import PrivacyPolicyPageArLite from './components/PrivacyPolicyPageArLite';
import PrivacyPolicyPageDeLite from './components/PrivacyPolicyPageDeLite';
import PrivacyPolicyPageEsLite from './components/PrivacyPolicyPageEsLite';
import PrivacyPolicyPageFrLite from './components/PrivacyPolicyPageFrLite';
import PrivacyPolicyPageHiLite from './components/PrivacyPolicyPageHiLite';
import PrivacyPolicyPageIdLite from './components/PrivacyPolicyPageIdLite';
import PrivacyPolicyPageItLite from './components/PrivacyPolicyPageItLite';
import PrivacyPolicyPageJaLite from './components/PrivacyPolicyPageJaLite';
import PrivacyPolicyPageRuLite from './components/PrivacyPolicyPageRuLite';
import PrivacyPolicyPageTrLite from './components/PrivacyPolicyPageTrLite';
import PrivacyPolicyPageZhLite from './components/PrivacyPolicyPageZhLite';
// ... Autres importations pour chaque langue

import PrivacyPolicyWallpaperio from './components/PrivacyPolicyWallpaperio'; // Importez le composant
import LicensePageWallio from './components/LicensePageWallio'; // Importez le composant
import PrivacyPolicyAd from './components/PrivacyPolicyAd';

import './App.css';

function App() {
    return (
        <Router>
            <div className="App">
                <Routes>
                    {/* Routes avec Navbar et Footer */}
                    <Route path="/" element={<><Navbar /><Home /><Footer /></>} />
                    <Route path="/application" element={<><Navbar /><Application /><Footer /></>} />
                    <Route path="/about" element={<><Navbar /><About /><Footer /></>} />
                    <Route path="/contact" element={<><Navbar /><Contact /><Footer /></>} />
                    <Route path="/services" element={<><Navbar /><Services /><Footer /></>} />

                    {/* Routes sans Navbar et Footer */}
                    <Route path="/license" element={<LicensePage />} />
                    <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
                    <Route path="/license-wallio" element={<LicensePageWallio />} />
                    <Route path="/privacy-policy-wallpaperio" element={<PrivacyPolicyWallpaperio />} />
                    <Route path="/privacy-policy-ad" element={<PrivacyPolicyAd />} />

                    {/* Routes pour les politiques de confidentialité en différentes langues */}
                    <Route path="/privacy-policy-ar" element={<PrivacyPolicyPageAr />} />
                    <Route path="/privacy-policy-de" element={<PrivacyPolicyPageDe />} />
                    <Route path="/privacy-policy-es" element={<PrivacyPolicyPageEs />} />
                    <Route path="/privacy-policy-fr" element={<PrivacyPolicyPageFr />} />
                    <Route path="/privacy-policy-hi" element={<PrivacyPolicyPageHi />} />
                    <Route path="/privacy-policy-id" element={<PrivacyPolicyPageId />} />
                    <Route path="/privacy-policy-it" element={<PrivacyPolicyPageIt />} />
                    <Route path="/privacy-policy-ja" element={<PrivacyPolicyPageJa />} />
                    <Route path="/privacy-policy-ru" element={<PrivacyPolicyPageRu />} />
                    <Route path="/privacy-policy-tr" element={<PrivacyPolicyPageTr />} />
                    <Route path="/privacy-policy-zh" element={<PrivacyPolicyPageZh />} />
                    
                    <Route path="/privacy-policy-Lite-ar" element={<PrivacyPolicyPageArLite />} />
                    <Route path="/privacy-policy-Lite-de" element={<PrivacyPolicyPageDeLite />} />
                    <Route path="/privacy-policy-Lite-es" element={<PrivacyPolicyPageEsLite />} />
                    <Route path="/privacy-policy-Lite-en" element={<PrivacyPolicyPageEnLite />} />
                    <Route path="/privacy-policy-Lite-fr" element={<PrivacyPolicyPageFrLite />} />
                    <Route path="/privacy-policy-Lite-hi" element={<PrivacyPolicyPageHiLite />} />
                    <Route path="/privacy-policy-Lite-id" element={<PrivacyPolicyPageIdLite />} />
                    <Route path="/privacy-policy-Lite-it" element={<PrivacyPolicyPageItLite />} />
                    <Route path="/privacy-policy-Lite-ja" element={<PrivacyPolicyPageJaLite />} />
                    <Route path="/privacy-policy-Lite-ru" element={<PrivacyPolicyPageRuLite />} />
                    <Route path="/privacy-policy-Lite-tr" element={<PrivacyPolicyPageTrLite />} />
                    <Route path="/privacy-policy-Lite-zh" element={<PrivacyPolicyPageZhLite />} />
                    {/* Ajoutez des routes similaires pour les autres langues */}
                    {/* ... */}
                </Routes>
            </div>
        </Router>
    );
}

export default App;
